export const setViews = (state, params) => {
	const { payload: views } = params;
	state.views = views;
	return state;
};


export const setStyle = (state, params) => {
	const { payload: tipoEstilo } = params;
	state.tipoEstilo = tipoEstilo;
	return state;
};

export default {};